import { Component } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { FuseConfigService } from '../../core/services/config.service';
import { FuseConfirmDialogComponent } from '../../core/components/confirm-dialog/confirm-dialog.component';
import { ChangePasswordComponent } from '../content/components/change-password/change-password.component';
import { UserService } from '../content/services/user.service';
import { AppService } from '../content/services/app.service';
import { MatDialogRef, MatDialog } from '@angular/material';
import { ComponentService } from '../content/services/component.service';

@Component({
    selector: 'fuse-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss']
})

export class FuseToolbarComponent {
    userStatusOptions: any[];
showLoadingBar: boolean;
horizontalNav: boolean;
response: any = {};
DisplayName: string = "";
translations: any;
userInfo: any;
ImageUrl : string = "assets/images/avatars/profile.jpg";
changePwdDialogRef: MatDialogRef<ChangePasswordComponent>;

constructor(
    private fuseConfig: FuseConfigService,
    public _router: Router,
    private userService: UserService,
    public appService: AppService,
    public dialog: MatDialog,
    private configService: ComponentService,
) {  
    if(sessionStorage.pageList != undefined)
        this.userInfo = JSON.parse(sessionStorage.pageList)[0];
    this.setPageTranslations();
    this.appService.showLoading();
    _router.events.subscribe(
        (event) => {
            if (event instanceof NavigationStart) {
                this.showLoadingBar = true;
            }
            if (event instanceof NavigationEnd) {
                this.showLoadingBar = false;
            }
        });

    this.fuseConfig.onSettingsChanged.subscribe((settings) => {
        this.horizontalNav = settings.layout.navigation === 'top';
    });

    // this.userService.profile().subscribe(
    //     res => this.profileSuccessCallback(res),
    //     error => this.profileErrorCallback(error)
    // );
}

setPageTranslations(){
    //        if(sessionStorage.getItem('pageData') != '')
    //            this.translations = JSON.parse(sessionStorage.getItem('pageData')); 
    this.configService.get('dashboard').subscribe((res) => {
        this.translations = JSON.parse(res['Data']);
        this.appService.hideLoading();
    });

} 

logout(): void {
    this.appService.showLoading();
    sessionStorage.clear();
    let pageName = 'login';
    sessionStorage.setItem('pageName', pageName);
    this.translations = undefined;
    this._router.navigateByUrl('/login')        
}
ngOnInit() {

}

apiFailure(error): void {

    this._router.navigateByUrl('/login')
}
profileSuccessCallback(res): void {
    this.appService.hideLoading();
    if (res['Status'] == '1') {
    this.DisplayName = JSON.parse(res['Data'])[0].DisplayName;
    if(JSON.parse(res['Data'])[0].ImageURL != '')
    this.ImageUrl = JSON.parse(res['Data'])[0].ImageURL;
}
else {
    this.profileErrorCallback(res.Message)
}
}

profileErrorCallback(error): void {
    this.logout();
}
changePwdDialog(){
    this.changePwdDialogRef = this.dialog.open(ChangePasswordComponent, {
        disableClose: false
    });
}

}





// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/toolbar/toolbar.component.ts